
import { orderReturnHistoryDetailModel, GetRMAStatusDetailParamater, updateRMAStatus } from "@NA/Services/ADIRMAStatusDetailsService";
import { CustomApiHandler } from "@NA/Store/CustomHandlerCreator/CustomHandlerCreator";
import {
    HasOnError,
    HasOnSuccess,
    createHandlerChainRunnerOptionalParameter,
} from "@insite/client-framework/HandlerCreator";

type HandlerType = CustomApiHandler<GetRMAStatusDetailParamater & HasOnSuccess & HasOnError, orderReturnHistoryDetailModel>;

export const DispatchLoadingRMAStatusDetails: HandlerType = (props: any) => {
    props.dispatch({
        type: "Custom/DispatchLoadingRMAStatusDetails",
        result: null,
    });
};

export const LoadADIRMAStatus: HandlerType = async (props: any) => {
    props.apiResult = await updateRMAStatus(props.parameter);
};

export const DispatchCompleteLoadADIRMAStatus: HandlerType = props => {
    props.dispatch({
        type: "Custom/DispatchCompleteRMAStatusDetails",
        result: props.apiResult,
    });
};
export const chain = [DispatchLoadingRMAStatusDetails,LoadADIRMAStatus, DispatchCompleteLoadADIRMAStatus];

const adiRMAStatusDetails = createHandlerChainRunnerOptionalParameter(
    chain,
    {
        rmaReturnId: "",
    },
    "RMAStatus",
);
export default adiRMAStatusDetails;
